module.exports = "<xo-generic-message token=token></xo-generic-message>\n"


//////////////////
// WEBPACK FOOTER
// ./pages/xo-generic-message/template.html
// module id = ./pages/xo-generic-message/template.html
// module chunks = 0